import { library } from '@fortawesome/fontawesome-svg-core'
import { 
    faTiktok
} from '@fortawesome/free-brands-svg-icons'
library.add(faTiktok)